export function getNextStepOfFlow(nodes, edges, activeNodeId, isCompleted) {

    const edgesMap = edges.reduce((acc, edge) => {
        if (!acc[edge.source]) acc[edge.source] = [];
        acc[edge.source].push(edge);
        return acc;
    }, {});

    const activeNodeEdges = edgesMap[activeNodeId] || [];
    
    for (const edge of activeNodeEdges) {
        if (isCompleted && edge.sourceHandle === 'destination') {
            return edge.target;
        } else if (!isCompleted && edge.sourceHandle === 'reject') {
            return edge.target;
        }
    }
    return null;
}

export function convertDateFromString(dateStr) {
    // Parse the date string
    const date = new Date(dateStr);
    
    // Format the date and time
    const options = { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        hour12: true 
    };

    // Convert to MM-DD-YYYY HH:MM A format
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

    return formattedDate;
}
export function checkForAccessLevel(userData,taskData,dealName,lookUpDeal,dataForAccessControl,AllUsers,allCacheUserRoles,allCacheRoles,moduleContacts) {
    const userEmail = userData?.email_id;
    const user = AllUsers?.find(user=>user.email==userEmail);
    const userZuid = user ? user.zuid : "";
    const TEAMS = dataForAccessControl?.TeamsData || [];
    const AccessData = dataForAccessControl?.AccessData || []; 
    let userAccess = "none";  
    const accessPriority = { none: 0, read: 1, write: 2 };
    const resolveEmailFromUserId = (userId) => {
      return Object.values(moduleContacts || {}).flat()?.find(k => k.id == userId)?.Email;
    }; 
    const isUserInTeam = (teamLabel) => {
      const match = /^Team_(\d+)_/.exec(teamLabel);
      if (!match) return false; 
      const teamId = parseInt(match[1]);
      const team = TEAMS.find(t => t.ROWID === teamId);
      if (!team) return false; 
      return team.Members?.map(String).includes(String(userZuid));
    }; 
    for (const entry of AccessData) {
      const level = entry.access;
      const targets = entry.target || []; 
      for (const target of targets) { 
        if (typeof target === "string" && target.startsWith("Team_")) {
          if (isUserInTeam(target)) {
            if (accessPriority[level] > accessPriority[userAccess]) {
              userAccess = level;
            }
          }
          continue;
        }else if(typeof target === "string" && target == "Assignee"){
            if(taskData.Assignee==userZuid){
                if (accessPriority[level] > accessPriority[userAccess]) {
                    userAccess = level;
                  }
            }
          continue;
        } 
        const targetStr = String(target); 
        if (targetStr === String(userZuid)) {
          if (accessPriority[level] > accessPriority[userAccess]) {
            userAccess = level;
          }
          continue;
        } 
        const matchingRoles = allCacheUserRoles?.filter(el => el.RoleId == targetStr &&(el.ProjectId == dealName || el.ProjectId == lookUpDeal?.Account_Name?.id)); 
        for (const role of matchingRoles || []) {
          const resolvedEmail = resolveEmailFromUserId(role.UserId);
          if (resolvedEmail === userEmail) {
            if (accessPriority[level] > accessPriority[userAccess]) {
              userAccess = level;
            }
          }
        }
      }
    } 
    for (const entry of AccessData) {
        const level = entry.access;
        const targets = entry.target || []; 
        for (const target of targets) { 
            if(userAccess=='none' && target=="EverybodyElse"){
                userAccess=level;
            }
        }
    }
    return userAccess;
  } 

// Moved code for migration from ProjecTasks component. written by Makarand Kshirsagar

// Utility: Build metadata for all deal/project fields for criteria UI
export function getProjectFieldMeta(allDealsAndUsers) {
   
  if (!Array.isArray(allDealsAndUsers) || allDealsAndUsers.length === 0) return [];
  const sampleDeal = allDealsAndUsers[0];
  return Object.keys(sampleDeal).map(key => {
    let type = 'DEFAULT'; // Default type
    // If it's an object with a 'name', treat as USER or PICKLIST
    if (sampleDeal[key] && typeof sampleDeal[key] === 'object' && sampleDeal[key].name) {
      type = 'TEXT';
    }
    // If it's an array, treat as MULTI-PICKLIST
    if (Array.isArray(sampleDeal[key])) {
      type = 'MULTI-PICKLIST';
    }
    return {
      label: key.replace(/\$/g, '').replace(/_/g, ' '), // <- removed $ and replaced _ with space
      field: key,
      type,
      module: 'Project',
    };
  });
}

// Utility: Get unique values for a given project field (for populating 'last' dropdown)
export function getProjectFieldUniqueValues(allDealsAndUsers, field) {
  if (!Array.isArray(allDealsAndUsers)) return [];
  const values = allDealsAndUsers.map(deal => {
    const val = deal[field];
    if (val && typeof val === 'object' && val.name) return val.name;
    return val;
  });
  // Remove undefined/null and deduplicate
  return [...new Set(values.filter(v => v !== undefined && v !== null))];
}